export const TAB_LABELS = [
  { key: 'GDA', label: 'GDAs' },
  { key: 'VDA', label: 'VDAs' },
  { key: 'DDA', label: 'DDAs' },
  { key: 'DISEASES', label: 'DISEASES' },
  { key: 'GENES', label: 'GENES' },
  { key: 'VARIANTS', label: 'VARIANTS' },
  { key: 'CHEMICALS', label: 'CHEMICALS' },
];

export const DOWNLOAD_EXTENSIONS = [
  { label: 'TSV', value: 'tsv' },
  { label: 'Excel', value: 'xlsx' },
];

export const EVIDENCE_LEGEND = (
  <div className="pb-16" data-testid="evidence-legend">
    <ul className="evidence-legend">
      <li>
        <span className="gene"></span> GENE
      </li>
      <li>
        <span className="variant"></span> VARIANT
      </li>
      <li>
        <span className="disease"></span> DISEASE
      </li>
      <li>
        <span className="negation_marker"></span> NEGATION MARKER
      </li>
      <li>
        <span className="chemical"></span> CHEMICALS
      </li>
    </ul>
  </div>
);
